import { cn } from "@/lib/utils";
import type { Status } from "@/components/api/companiesApi";

// Status → badge styling. Colors are chosen to read on the app's dark theme
// (semi-transparent color fill + light text) while following the palette in
// plans/CMS.md §3.
const STATUS_CLASS: Record<Status, string> = {
    New: "bg-secondary text-secondary-foreground border-border",
    Contacted: "bg-blue-500/15 text-blue-300 border-blue-500/30",
    "In process": "bg-violet-500/15 text-violet-300 border-violet-500/30",
    "Attention needed": "bg-amber-500/15 text-amber-300 border-amber-500/30",
    Won: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    Lost: "bg-muted/40 text-muted-foreground border-border line-through decoration-1",
};

interface StatusBadgeProps {
    status: Status;
    className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
    return (
        <span
            className={cn(
                "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
                STATUS_CLASS[status],
                className,
            )}
        >
            {status}
        </span>
    );
}
